import fbPixelHelper from "../../site/fb-pixel-helper";
import {PortedVueFormController} from "../../site/lib/ported-vue-forms-helpers";
import {AbstractFormController, FormState} from "../../site/lib/AbstractFormController";

class AffiliateFormController extends AbstractFormController {
	readonly controller: PortedVueFormController;
	private readonly fullSignup: boolean;

	constructor(container: HTMLDivElement, form: HTMLFormElement) {
		super(container, form);
		this.fullSignup = this.container.getAttribute("data-form-mode") !== 'lead-only';
		(window as any).testDummy = this;

		this.controller = new PortedVueFormController(form, JSON.parse(container.getAttribute("data-base-form-state") ?? "{data: {}}") as FormState);
		this.controller.setFormStateValue('data.time_zone', new Date().toLocaleDateString('en-US', {day: '2-digit', timeZoneName: 'short'}).slice(4));
		this.controller.setFormStateValue('data.utm_params', this.storeUTMParameters());

		this.controller.triggerWatches(new Event('formController.setup'));
	}

	protected async sendBaseForm() {
		const data: Record<string, any> = {
			heard_of_type_id: 19,
			heard_of_other: "",
			email_verification: this.controller.getFormStateValue("email"),
			...this.controller.formState
		};
		if (this.controller.getFormStateValue('area_of_service_type_id') !== 2 && this.fullSignup) {
			await fetch(`/wp-json/homes-for-heroes/v1/protected-zips/is?zip=${this.controller.getFormStateValue('zip_code')}`)
				.then(resp => resp.json())
				.then(json => (data.data ?? (data.data = {}))['received_protected_zip_warning'] = !!json)
				.catch(err => console.error(err));
		}

		this.doJsonFetch(this.container.getAttribute("data-endpoint")!, 'post', {'Content-Type': 'application/json'}, JSON.stringify(data))
			.then(response => {
				this.response.success = true;
				if (this.fullSignup) {
					this.response.body = response.data;
					this.createCookie("rebate_state", response.data.rebateState, 30);
					this.createCookie("affiliate_state", response.data?.state ?? response.state, 30);
					this.createCookie("area_of_service_type_id", this.controller.getFormStateValue('area_of_service_type_id')?.toString() ?? '', 30);
				} else {
					this.response.body = {};
				}
			})
			.catch(error => {
				console.error(error);
				this.response.success = false;
				this.setSubmitButtonState(false);
				this.response.body = Object.values((error.response.data ?? error.response).errors).map((i: any) => i[0]);
			})
			.finally(() => {
				fbPixelHelper.triggerAffiliateCompleteRegistrationEvent(
					this.controller.getFormStateValue("email")?.toString().trim().toLowerCase(),
					this.controller.getFormStateValue("phone")?.toString().replace(/\D/g, '').replace(/^0*/, '1')
				);
				this.handleResponse();
				if (this.response.success) {
					this.redirectToSuccessPage();
				}
			});
	}

	private redirectToSuccessPage() {
		const payload: Record<string, string> = {};

		const laravelFakeURL: string | undefined = this.response.body.url?.toString();
		if (this.fullSignup && laravelFakeURL) {
			for (const [key, value] of new URL(laravelFakeURL).searchParams) {
				payload[key] = value;
			}
		}
		if (!payload['zipcode']) {
			payload['zipcode'] = this.controller.getFormStateValue('zip_code')?.toString() ?? '';
		}
		if (!payload['campaign_id']) {
			payload['campaign_id'] = this.controller.getFormStateValue('campaign_id')?.toString() ?? '';
		}
		if (this.response.body.signup_id) {
			payload['signup_id'] = this.response.body.signup_id;
		}

		const successPageUrl = this.container.getAttribute('data-success-page-url') ?? '';

		fetch('/wp-json/homes-for-heroes/v1/success-token', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
		})
			.then(resp => resp.json())
			.then((data: { token: string }) => {
				const url = new URL(successPageUrl);
				url.searchParams.set('token', data.token);
				window.location.href = url.toString();
			})
			.catch(err => {
				console.error('Failed to store success token:', err);
				window.location.href = successPageUrl;
			});
	}

	protected getResponseErrorList(): string[] {
		return this.response.body as string[];
	}
}

for (const container of document.querySelectorAll<HTMLDivElement>("div.wp-block-plaudit-affiliate-signup-form")) {
	const form = container.querySelector("form");
	if (form) {
		new AffiliateFormController(container, form);
	}
}
